<template>
  <div class="hello">
    <div class="drawingBoardBox">
      <!-- 标题 -->
      <div class="title">
        <div class="TitleleftIcon">
          <div class="leftIconBox">
            <div class="leftIcon1"></div>
            <div class="leftIcon2"></div>
            <div class="leftIcon3"></div>
            <div class="leftIcon4"></div>
          </div>
        </div>
        <div class="titleText">{{KanbanTitle}}测评实时数据看板</div>
        <div class="TitleRightIcon">
          <div class="timer">{{timer}}</div>
          <div class="rightIconBox">
            <div class="rightIcon1"></div>
            <div class="rightIcon2"></div>
            <div class="rightIcon3"></div>
            <div class="rightIcon4"></div>
          </div>
        </div>
      </div>
      <div class="infoBox">
        <!-- 左侧 -->
        <div class="leftBox">
          <!-- 已测人数 -->
          <div class="testedPeopleNumber">
            <canvas width="500" height="500" class="background-canvas"></canvas>  
            <div class="testedPeopleNumberTitle">已测人数(周)
              <div class="weekly"><span class="weeklyIcon"></span>每周</div>
              <div class="Cumulative"><span class="CumulativeIcon"></span>累计</div>
            </div>
            <div id="testedPeopleEcharts" style="width: 500px;height:420px;" class="testedPeople"></div>
          </div>
          <!-- 在线人数 -->
          <div class="onlinePeopleNumber">
            <canvas width="500" height="500" class="background-canvas"></canvas>
            <div class="onlinePeopleNumberTitle">当前在线(时)</div>
            <div id="onlinePeopleEcharts" style="width: 500px;height:420px;" class="onlinePeople"></div>
          </div>
        </div>
        <!-- 中间 -->
        <div class="centerBox">
          <!-- 心理健康结果 -->
          <div class="mentalHealthResult">
            <div class="mentalHealth">
              <div class="mentalHealthTitle">{{ mentalHealthTitle }}</div>
              <div id="mentalHealthResultEcharts" style="width: 800px;height:800px;"></div>
            </div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="rightBox">
          <!-- 学院分布 -->
          <div class="collegeDistribute">
            <canvas width="500" height="500" class="background-canvas"></canvas>  
            <div class="collegeDistributeTitle">学院分布</div>
            <div class="collegeDistributeBox">
              <div class="collegeDistributeNumber" v-for="(item, index) in collegeDistribute" :key="index">
                <div class="collegeName">{{item.name}}</div>
                <div class="allNumber" ref="allNumberWidth">
                  <div class="collegePeopleNumber" :style="{'width': averageCollegeDistributeNum(item.value)}">{{item.value}}人
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 量表分布 -->
          <div class="scaleType">
            <canvas ref="scaleType" width="500" height="500" class="scaleTypeCanvas"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import HighCharts from 'highcharts'

export default {
  name: 'index',
  props: {
    msg: String
  },
  data() {
    return{
      creator: this.$route.params.creator, // 用户id
      timer: '', // 时间
      KanbanTitle: '', // 看板标题
      allTestedPeople: [], // 已测总人数
      weeklyTestedPeople: [], // 已测周人数
      onlinePeople: [],  // 在线人数
      mentalHealthTitle: '心理健康结果', // 饼图标题
      mentalHealthResult: [], // 心理健康结果
      scaleTypeData: [], // 量表使用人数
      collegeDistribute: [], // 学院分布
    }
  },
  created() {
    // 获取时间
    this.startTime()
    // 获取看板
    this.getKanbanInfo().then(() => {
      document.title = this.KanbanTitle + '测评实时数据看板'
    })
    // 加载所有数据
    this.loadAllData()
    // 刷新
    let s = 5*60*1000
    setInterval(() => {
      this.loadAllData()
    }, s)    
  },
  mounted() {
    this.$nextTick(() => {
      // 获取设备dpr
      this.dpr = window.devicePixelRatio
      // 绘制背景框
      this.drawBackground()     
    })
  },
  methods: {
    // 各学院分布占比重
    averageCollegeDistributeNum (value) {   
      let maxValue = this.collegeDistribute[0].value * 1.2
      let ratio = value/maxValue * 100
      return ratio + '%'
    },
    // 处理高分屏显示模糊问题
    scaleHandle (canvas, ctx, dpr) {
      // 获取css的宽高
      let { width: cssWidth, height: cssHeight } = canvas.getBoundingClientRect()
      // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
      canvas.style.width = canvas.width + 'px'
      canvas.style.height = canvas.height + 'px'
      canvas.width = dpr * cssWidth
      canvas.height = dpr * cssHeight
      // 由于画布扩大，canvas的坐标系也跟着扩大，如果按照原先的坐标系绘图内容会缩小
      // 所以需要将绘制比例放大
      ctx.scale(dpr, dpr)
    },
    // 获取看板标题
    async getKanbanInfo () {
      let res = await this.$axios.get(`REST/getKanbanInfo?creator=${this.creator}`)
      // console.log(res)
      if(res.status === 200) {
        this.KanbanTitle = res.data.school;
      }
      
    },
    // 获取已测人数/周及累积人数
    async getTestedPeopleData () {
      let res = await this.$axios.get(`REST/getWeeklyAssTesters?creator=${this.creator}`)
      if(res.status === 200) {
        this.weeklyTestedPeople = res.data[0];
        this.allTestedPeople = res.data[1]
      }
    },
    // 获取当前在线人数/小时
    async getonlinePeopleData () {
      let res = await this.$axios.get(`REST/getCurAssTesters?creator=${this.creator}`)
      if(res.status === 200) {
        this.onlinePeople = res.data
      }
    },
    // 获取心理健康结果数据
    async getMentalHealthResultData () {
      console.log(this.creator)
      if(this.creator == 381) {
        this.mentalHealthTitle = '胜任力结果'
        let res = await this.$axios.get(`REST/getAssFinalScores?creator=${this.creator}`)
        if(res.status === 200) {
          this.mentalHealthResult = res.data
          console.log(this.mentalHealthResult)
        }
      } else {
        let res = await this.$axios.get(`REST/getAssResultByType?creator=${this.creator}&prodId=276`)
        if(res.status === 200) {
          this.mentalHealthResult = res.data
        }
      }
      
    },
    // 获取学院分布数据
    async getCollegeDistributeData () {
      let res = await this.$axios.get(`REST/getAssTestersByCollege?creator=${this.creator}`)
      if(res.status === 200) {
        this.collegeDistribute = this.dataHandle(res.data).slice(0,8)
      }
    },
    // 获取量表使用人数数据
    async getscaleTypeData () {
      let res = await this.$axios.get(`REST/getAssTestersByProds?creator=${this.creator}`)
      if(res.status === 200) {
        this.scaleTypeData = this.dataHandle(res.data)
      }
    },
    // 数据处理，将对象转为数组，并排序
    dataHandle (data) {
      let arrayData = []
      for(let i in data) {
        arrayData.push({name: i,value: data[i]})
      }
      arrayData.sort((a,b)=>{return b.value - a.value})
      return arrayData
    },
    // 绘制已测人数图标
    drawTestedPeopleEcharts () {
      let XAXIS = [], YAXIS = {bar:[],line:[]}
      for(let i in this.weeklyTestedPeople) {
        XAXIS.push(i.slice(5))
        YAXIS.bar.push(this.weeklyTestedPeople[i])
      }
      for(let i in this.allTestedPeople) {
        YAXIS.line.push(this.allTestedPeople[i])
      }
      let maxValueOfBar = [...YAXIS.bar.slice(0,11).reverse()].sort((a,b)=>b-a)[0]
      let maxValueOfLine = [...YAXIS.line.slice(0,11).reverse()].sort((a,b)=>b-a)[0]
      let minValueOfLine = [...YAXIS.line.slice(0,11).reverse()].sort((a,b)=>a-b)[0]

      let charts = echarts.init(document.getElementById('testedPeopleEcharts'))
      charts.setOption({
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          toolbox: {
              feature: {}
          },
          legend: {},
          xAxis: [
              {
                  type: 'category',
                  data: XAXIS.slice(0,11).reverse(),
                  axisPointer: {
                      type: 'shadow'
                  },
                  axisLabel: {
                      interval: 0,
                      rotate: 40,
                      show: true,
                      textStyle: {    //x坐标轴文字样式
                          color: "rgba(27, 99, 157, 1)",
                          fontSize: 12
                      }
                  },
                  axisTick:{ //x轴刻度线
                      show:false
                  },
                  axisLine:{ //x坐标轴样式
                      lineStyle:{
                          color:'rgba(26, 96, 153, 1)',
                          width:1,
                      }
                  } 
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  name: '人数',
                  min: 0,
                  max: Math.floor(maxValueOfBar*1.1),
                  interval: Math.floor(maxValueOfBar/6),
                  axisLabel: {
                      formatter: '{value}',
                      interval: 0,
                      rotate: 40,
                      textStyle: {    //x坐标轴文字样式
                          color: "rgba(27, 99, 157, 1)",
                          fontSize: 12
                      }
                  },
                  splitLine:{
                      show:false
                  },
                  axisTick:{    //y轴刻度线
                      show:false
                  },
                  splitArea : {  //图表背景网格的颜色
                      show : true,   
                      areaStyle : {
                        color: ['rgba(65, 66, 101, 0.2)', 'rgba(10, 19, 65, 1)']
                      }
                  },
                  axisLine:{ //y坐标轴样式
                      lineStyle:{
                          color:'rgba(26, 96, 153, 1)',
                          width:2,
                      }
                  } 
              },
              {
                  type: 'value',
                  name: '累计',
                  min: Math.floor(minValueOfLine*0.99),
                  max: Math.floor(maxValueOfLine*1.01),
                  interval: Math.floor((maxValueOfLine-minValueOfLine)/6),
                  axisLabel: {
                      formatter: '{value}',
                      interval: 0,
                      rotate: 40,
                      show: true,
                      textStyle: {    //x坐标轴文字样式
                          color: "rgba(27, 99, 157, 1)",
                          fontSize: 12
                      }
                  },
                  splitLine:{
                      show:false
                  },
                  axisTick:{    //y轴刻度线
                      show:false
                  },
                  axisLine:{ //y坐标轴样式
                      lineStyle:{
                          color:'rgba(26, 96, 153, 1)',
                          width:2,
                      }
                  } 
              }
          ],
          series: [
              {
                  type:'bar', //柱形图
                  barWidth: '24px',
                  data: YAXIS.bar.slice(0,11).reverse(),
                  label: {
                    normal: {
                      show: true,
                      position: 'top',
                      color: "#fff"
                    }
                  },
                  itemStyle: {
                  normal: {
                    // barBorderRadius:[24, 24, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: "#48a2e1"
                    }, 
                    {
                      offset: 0.5,
                      color: "#4e5ef1"
                    },
                    {
                      offset: 1,
                      color: "#5215ff"
                    }], false)
                  }
                }	
              },
              {
                  type:'line', //折线图
                  symbol: 'circle',
                  symbolSize: 5,
                  yAxisIndex: 1,
                  data: YAXIS.line.slice(0,11).reverse(),
                  itemStyle: {
                      normal: {
                        lineStyle: {
                          color: 'rgba(10, 250, 159, 1)'
                        },
                        color: "rgba(2, 255, 206, 1)",
                        borderWidth: 1,
                        borderColor: 'rgba(2, 255, 206, 1)',
                      }
                  },
                  
              }
          ]
      })
    },
    // 绘制在线人数
    drawOnlinePeopleNumberEcharts () {
      // console.log(this.onlinePeople)
      let XAXIS = [], YAXIS = []
      for(let i in this.onlinePeople) {
        XAXIS.push(i.split(" ")[1])
        YAXIS.push(this.onlinePeople[i])
      }
      let maxValue = [...YAXIS.reverse().slice(0, 11)].sort((a,b)=>b-a)[0]
      let avgInterval = 1
      if(maxValue === 0) {
        maxValue = 4
      } else if (maxValue < 10) {
        maxValue = maxValue*2
      } else if (maxValue >= 10) {
        maxValue = maxValue*2
        avgInterval = Math.floor(maxValue/4)
      }
      let charts = echarts.init(document.getElementById('onlinePeopleEcharts'))

      charts.setOption({
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: XAXIS.slice(0,11).reverse(),
            axisLine:{ //x坐标轴样式
                lineStyle:{
                    color:'rgba(26, 96, 153, 1)',
                    width:2,
                }
            },
            axisTick:{
                show:false
            },
            axisLabel: {
                interval: 0,
                rotate: 40
            },
        },
        yAxis: {
            type: 'value',
            name: '人数',
            min: 0,
            max: maxValue,
            interval: avgInterval,
            splitLine:{ //网格线
                show:false
            },
            axisTick:{
                show:false
            },
            axisLabel: {
                interval: 0,
                rotate: 40
            },
            axisLine:{ //y坐标轴样式
                lineStyle:{
                    color:'rgba(26, 96, 153, 1)',
                    width:2,
                }
            } 
        },
        series: [{
            data: YAXIS.slice(0, 11).reverse(),
            type: 'line',
            symbol: 'circle',
            symbolSize: 5,
            itemStyle: {
                normal: {
                  lineStyle: {
                    color: 'rgba(10, 250, 159, 1)'
                  },
                  color: "rgba(2, 255, 206, 1)",
                  borderWidth: 1,
                  borderColor: 'rgba(2, 255, 206, 1)',
                }
              },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(26, 179, 148, 1)'
                }, {
                    offset: 1,
                    color: 'rgba(26, 179, 148, 0)'
                }])
            },
        }]
      })
    },
    // 绘制心理健康结果饼图
    drawMentalHealthResultEcharts () {
      let arrayMentalHealthResult = []
      let arrayTotal = 0
      for(let i in this.mentalHealthResult) {
        arrayMentalHealthResult.push({name: i, value: this.mentalHealthResult[i]})
        arrayTotal += this.mentalHealthResult[i]
      }

      HighCharts.setOptions({
        colors: ['rgba(223, 113, 246, 1)','rgba(249, 206, 91, 1)','rgba(73, 185, 170, 1)']
      });
      HighCharts.getOptions().colors = HighCharts.map(HighCharts.getOptions().colors, function (color) {
        return {
          radialGradient: { cx: 0.5, cy: 0.3, r: 0.8 }, //光线坐标
          stops: [
            [0, color],
            [1, HighCharts.Color(color).brighten(-0.4).get('rgb')] // darken
          ]
        };
      });    
      
      let option = {
        chart: {
          backgroundColor: 'rgba(0,0,0,0)',
          type: 'variablepie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        title: { //标题样式
          floating: true,
          text: `总人数<br><span style="color: rgba(35, 195, 163, 1);font-size: 36px;font-weight: bold;">${arrayTotal}</span><br/>`,
          align: 'center',
          verticalAlign: 'middle',
          // x: 400,
          // y: 300,
          style: {
            color: '#fff',
            fontSize: '24px'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              distance: 20,
              format: `{point.name}<br/>{point.y}人，占{point.percentage:.1f}%`,
              style: {
                 color:'#fff',
                 fontSize:'14px',
                 textOutline:"none"
              }
            }
          }
        },
        series: [{
          minPointSize: 30,
          innerSize: '60%',
          borderWidth: 0,
          zMin: 0,
          name: 'countries',
          data: [{
            name: 'A类（心理异常）',
            y: arrayMentalHealthResult[0] ? arrayMentalHealthResult[0].value : 0,
            z: 900
          }, {
            name: 'B类（基本正常）',
            y: arrayMentalHealthResult[1] ? arrayMentalHealthResult[1].value : 0,
            z: 1400
          }, {
            name: 'C类（心理正常）',
            y: arrayMentalHealthResult[2] ? arrayMentalHealthResult[2].value : 0,
            z: 1600
          }]
        }],
        credits: {  
          enabled: false     //不显示LOGO 
        } 
      }
      HighCharts.chart('mentalHealthResultEcharts', option, function(c) { // 图表初始化完毕后的会掉函数
        // 环形图圆心
        var center = c.series[0].center;
        // 标题字体大小，返回类似 16px ，所以需要 parseInt 处理
        var titleHeight = parseInt(c.title.styles.fontSize);   
        c.setTitle({
            x: 0,
            y: titleHeight
        });
        document.getElementById('mentalHealthResultEcharts').style.transform = `translate(${395 - center[0]}px,${420 - center[1]}px)`
      });
    },
    // 绘制胜任力结果饼图
    drawFinalResultEcharts () {
      let arrayMentalHealthResult = []
      let arrayMentalHealthResultArr = []
      let arrayTotal = 0
      console.log(this.mentalHealthResult)
      let sizeMap = 600
      for(let i in this.mentalHealthResult) {
        arrayMentalHealthResult.push({name: i, value: this.mentalHealthResult[i]})
        sizeMap = sizeMap + 400
        arrayMentalHealthResultArr.push({name: i, y: this.mentalHealthResult[i], z: sizeMap})
        arrayTotal += this.mentalHealthResult[i]
      }
      console.log(arrayMentalHealthResultArr)
      HighCharts.setOptions({
        colors: ['rgba(223, 113, 246, 1)','rgba(249, 206, 91, 1)','rgba(73, 185, 170, 1)','rgba(233, 134, 77, 1)','rgb(146, 254, 157)','rgb(33, 212, 253)']
      });
      HighCharts.getOptions().colors = HighCharts.map(HighCharts.getOptions().colors, function (color) {
        return {
          radialGradient: { cx: 0.5, cy: 0.3, r: 0.8 }, //光线坐标
          stops: [
            [0, color],
            [1, HighCharts.Color(color).brighten(-0.4).get('rgb')] // darken
          ]
        };
      });    
      
      let option = {
        chart: {
          backgroundColor: 'rgba(0,0,0,0)',
          type: 'variablepie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        title: { //标题样式
          floating: true,
          text: `总人数<br><span style="color: rgba(35, 195, 163, 1);font-size: 36px;font-weight: bold;">${arrayTotal}</span><br/>`,
          align: 'center',
          verticalAlign: 'middle',
          // x: 400,
          // y: 300,
          style: {
            color: '#fff',
            fontSize: '24px'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              distance: 20,
              format: `{point.name}<br/>{point.y}人，占{point.percentage:.1f}%`,
              style: {
                 color:'#fff',
                 fontSize:'14px',
                 textOutline:"none"
              }
            }
          }
        },
        series: [{
          minPointSize: 30,
          innerSize: '60%',
          borderWidth: 0,
          zMin: 0,
          name: 'countries',
          data: arrayMentalHealthResultArr
        }],
        credits: {  
          enabled: false     //不显示LOGO 
        } 
      }
      HighCharts.chart('mentalHealthResultEcharts', option, function(c) { // 图表初始化完毕后的会掉函数
        // 环形图圆心
        var center = c.series[0].center;
        // 标题字体大小，返回类似 16px ，所以需要 parseInt 处理
        var titleHeight = parseInt(c.title.styles.fontSize);   
        c.setTitle({
            x: 0,
            y: titleHeight
        });
        document.getElementById('mentalHealthResultEcharts').style.transform = `translate(${395 - center[0]}px,${420 - center[1]}px)`
      });
    },
    // 绘制量表使用人数图表
    drawScaleType () {
      let scaleType = this.$refs.scaleType;
      // 兼容性检测
      if (scaleType.getContext) {
        // 绘制
        let ctx = scaleType.getContext('2d')
        // 处理高分屏显示模糊问题
        this.scaleHandle(scaleType, ctx, this.dpr)
        // 开始绘制
        this.drawRenderScaleType(scaleType,ctx)
        // 监听点击事件
        // this.canvasEventLisenerHandle(scaleType)
      } else {
        alert('你的浏览器不支持 canvas，请升级你的浏览器。')
      }
    },
    // 绘制量表分布图
    drawRenderScaleType (scaleType, ctx) {
      this.drawBorder(scaleType, ctx)
      this.drawScaleTypeTitle(scaleType, ctx)
      this.drawScaleTypeBody(scaleType, ctx)
    },
    // 绘制外边框
    drawBorder (scaleType, ctx) {
      let width = scaleType.style.width.match(/\d*/g)[0]
      let height = scaleType.style.height.match(/\d*/g)[0]
      ctx.beginPath()
      // 左上角
      ctx.moveTo(1,1)
      ctx.lineTo(1,18)
      ctx.lineTo(18,1)
      ctx.lineTo(0,1)
      // 右上角
      ctx.moveTo( width - 18, 1)
      ctx.lineTo( width - 1, 1)
      ctx.lineTo( width - 1, 18)
      ctx.lineTo( width - 19, 0)
      // 右下角
      ctx.moveTo( width - 1, height - 18)
      ctx.lineTo( width - 1, height - 1)
      ctx.lineTo( width - 18, height - 1)
      ctx.lineTo( width, height - 19)
      // 左下角
      ctx.moveTo( 1, height - 18)
      ctx.lineTo( 1, height - 1)
      ctx.lineTo( 18, height - 1)
      ctx.lineTo( 0, height - 19)

      ctx.lineWidth = 2
      ctx.strokeStyle = 'rgba(4, 255, 244, 1)'
      ctx.stroke()
      ctx.closePath()
      // 边框
      ctx.beginPath()

      ctx.moveTo( 27, 1)
      ctx.lineTo( width - 27, 1)
      ctx.lineTo( width - 1, 27)
      ctx.lineTo( width - 1, height - 27)
      ctx.lineTo( width - 27, height - 1)
      ctx.lineTo( 27 , height - 1)
      ctx.lineTo( 1 , height - 27)
      ctx.lineTo( 1 , 27)
      ctx.lineTo( 27 , 0)

      ctx.lineWidth = 2
      ctx.strokeStyle = 'rgba(9, 241, 251, .2)'
      ctx.stroke()
      ctx.closePath()
    },
    // 绘制量表分布图 图标名字
    drawScaleTypeTitle(scaleType, ctx) {
      // 图表名
      ctx.beginPath()
      ctx.moveTo(26, 30);
      ctx.lineTo(26, 35)
      ctx.lineCap = "round"
      ctx.lineWidth = 6
      ctx.strokeStyle = "rgba(4, 255, 244, 1)"
      ctx.stroke()
      ctx.beginPath()
      ctx.font = "18px 'PingFang SC'"
      ctx.fillStyle = '#FFF'
      ctx.textAlign = 'left';
      ctx.fillText('量表分布', 39, 39);
      ctx.closePath()
    },
    // 绘制量表分布图柱体
    drawScaleTypeBody (scaleType, ctx) {
      // 柱体最高值
      let maxValue = this.scaleTypeData[0].value*1.2
      let width = scaleType.style.width.match(/\d*/g)[0]
      let height = scaleType.style.height.match(/\d*/g)[0]
      let startX = 46
      
      // X轴
      ctx.beginPath()
      ctx.moveTo(25, height - 59)
      ctx.lineTo(width - 25, height - 59 );
      ctx.lineWidth = 2
      ctx.strokeStyle = "rgba(26, 96, 153, 1)";
      ctx.stroke();
      ctx.closePath()


      this.scaleTypeData.some( (element, index) => {
        // 只画前五个
        if(index > 4) return true
        let labelX = 71 + index * 89 // 底部文字和数值文字的X坐标
        // 背影
        ctx.beginPath();
        ctx.moveTo(startX + 89 * index, height - 60);
        ctx.lineTo(startX + 89 * index, height - 60 - 338);
        ctx.lineTo(startX + 89 * index + 23, height - 60 - 338 + 13);
        ctx.lineTo(startX + 89 * index + 23, height - 60);
        ctx.lineTo(startX + 89 * index, height - 60);
        ctx.fillStyle = 'rgba(23, 44, 104, 1)';
        ctx.fill();
        ctx.closePath()
        ctx.beginPath();
        ctx.moveTo(startX + 25 + 89 * index, height - 60);
        ctx.lineTo(startX + 25 + 89 * index, height - 60 - 338 + 13);
        ctx.lineTo(startX + 25 + 89 * index + 23, height - 60 - 338);
        ctx.lineTo(startX + 25 + 89 * index + 23, height - 60);
        ctx.lineTo(startX + 25 + 89 * index, height - 60);
        ctx.fillStyle = 'rgba(33, 55, 118, 1)';
        ctx.fill();
        ctx.closePath()
        ctx.beginPath();
        ctx.moveTo(startX + 89 * index, height - 60 - 338 - 2);
        ctx.lineTo(startX + 89 * index + 24, height - 60 - 338 + 14 - 2);
        ctx.lineTo(startX + 89 * index + 48, height - 60 - 338 - 2);
        ctx.lineTo(startX + 89 * index + 24, height - 60 - 338 - 14 -2);
        ctx.lineTo(startX + 89 * index, height - 60- 338 -2);
        ctx.fillStyle = 'rgba(39, 61, 125, 1)';
        ctx.fill();
        ctx.closePath()
        // 数据柱体
        let dataHeight = element.value / maxValue * 338 + 14
        ctx.beginPath();
        ctx.moveTo(startX + 89 * index, height - 60);
        ctx.lineTo(startX + 89 * index, height - 60 - dataHeight);
        ctx.lineTo(startX + 89 * index + 24, height - 60 - dataHeight + 14);
        ctx.lineTo(startX + 89 * index + 24, height - 60);
        ctx.lineTo(startX + 89 * index, height - 60);
        ctx.fillStyle = 'rgba(40, 55, 193, 1)';
        ctx.fill();
        ctx.closePath()
        ctx.beginPath();
        ctx.moveTo(startX + 24 + 89 * index, height - 60);
        ctx.lineTo(startX + 24 + 89 * index, height - 60 - dataHeight + 14);
        ctx.lineTo(startX + 24 + 89 * index + 24, height - 60 - dataHeight);
        ctx.lineTo(startX + 24 + 89 * index + 24, height - 60);
        ctx.lineTo(startX + 24 + 89 * index, height - 60);
        ctx.fillStyle = 'rgba(59, 74, 218, 1)';
        ctx.fill();
        ctx.closePath()
        ctx.beginPath();
        ctx.moveTo(startX + 89 * index, height - 60 - dataHeight);
        ctx.lineTo(startX + 89 * index + 24, height - 60 - dataHeight + 14);
        ctx.lineTo(startX + 89 * index + 48, height - 60 - dataHeight);
        ctx.lineTo(startX + 89 * index + 24, height - 60 - dataHeight - 14);
        ctx.lineTo(startX + 89 * index, height - 60- dataHeight);
        ctx.fillStyle = 'rgba(86, 100, 237, 1)';
        ctx.fill();
        ctx.closePath()

        ctx.beginPath()
        ctx.font = "12px 'Source Han Sans CN'"
        ctx.fillStyle = '#FFF'
        ctx.textAlign = 'center';
        ctx.fillText(element.value, labelX, height - 60 - dataHeight - 22);
        this.textPrewrap(ctx, element.name, labelX, height - 40, 16, 80, 2)
        ctx.closePath()
      })
    },
    // 文字自动换行
    textPrewrap(ctx, content, drawX, drawY, lineHeight, lineMaxWidth, lineNum) {
      var drawTxt = ''; // 当前绘制的内容
      var drawLine = 1; // 第几行开始绘制
      var drawIndex = 0; // 当前绘制内容的索引

      // 判断内容是否可以一行绘制完毕
      if(ctx.measureText(content).width <= lineMaxWidth) {
        ctx.fillText(content.substring(drawIndex, i), drawX, drawY);
      } else {
        for (var i = 0; i < content.length; i++) {
          drawTxt += content[i];
          if (ctx.measureText(drawTxt).width >= lineMaxWidth) {
              if (drawLine >= lineNum) {
                ctx.fillText(content.substring(drawIndex, i) + '...', drawX, drawY);
                break;
              } else {
                ctx.fillText(content.substring(drawIndex, i + 1), drawX, drawY);
                drawIndex = i + 1;
                drawLine += 1;
                drawY += lineHeight;
                drawTxt = '';
              }
          } else {
            // 内容绘制完毕，但是剩下的内容宽度不到lineMaxWidth
            if (i === content.length - 1) {
              ctx.fillText(content.substring(drawIndex), drawX, drawY);
            }
          }
        }
      }
    },
    // 绘制背景
    drawBackground () {
      let canvasList = document.getElementsByClassName('background-canvas')
      Array.prototype.forEach.call(canvasList, (canvas) => {
        let ctx = canvas.getContext('2d')
        // 处理高分屏显示模糊问题
        this.scaleHandle(canvas, ctx, this.dpr)
        
        this.drawBorder(canvas,ctx)
      })
    },
    // 时间
    startTime(){
        
        setInterval(()=> {
            let today = new Date();
            let Year = today.getFullYear()
            let Month = today.getMonth()+1
            let dataDate = today.getDate()
            let h = today.getHours();
            let m = today.getMinutes()
            let s = today.getSeconds()
            m = this.checkTime(m)
            s = this.checkTime(s)

            this.timer = Year+"-"+Month+"-"+dataDate+"  "+h+":"+m+":"+s
        },995)
    },
    checkTime(i){
        if(i<10){
            i = "0"+i;
        }
        return i
    },
    // 刷新数据
    loadAllData() {
      let self = this
      // 获取已测人数/周及累积人数
      this.getTestedPeopleData().then( ()=> {
        this.$nextTick(()=> {
          // 绘制已测人数Echarts图
          this.drawTestedPeopleEcharts()
        })
      })
      // 获取当前在线人数/小时
      this.getonlinePeopleData().then( () => {
        this.$nextTick(() => {
          // 绘制在线人数Echarts图
          this.drawOnlinePeopleNumberEcharts()
        })
      })
      // 获取心理健康结果数据
      this.getMentalHealthResultData().then( () => {
        this.$nextTick(() => {
          if(self.creator == 381) {
            console.log('胜任力' + self.creator)
            // 绘制胜任力结果图
            this.drawFinalResultEcharts()
          } else {
            // 绘制心理健康结果图
            this.drawMentalHealthResultEcharts()
          }
          
        })
      })
      // 获取学院分布
      this.getCollegeDistributeData()
      // 获取量表分布
      this.getscaleTypeData().then(() => {
        // 绘制量表使用人数图表
        this.drawScaleType()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* @media not all, not all, only screen and (-webkit-min-device-pixel-ratio: 3), not all {
  .hello {
    background: url('./../assets/images/背景@2x.png');
    background-size: contain;
  }
}
@media not all, not all, only screen and (-webkit-min-device-pixel-ratio: 2), not all {
  .hello {
    background: url('./../assets/images/背景.png');
    background-size: contain;
  }
} */
.hello {
  width: 100%;
  height: 100%;
  min-width: 1920px;
  min-height: 1080px;
  background: url('./../assets/images/背景.png');
  background-size: contain;
  /* transform-origin: 0 0; */
  /* animation: appear 1s; */
  /* animation-fill-mode: forwards; */
}
/* @keyframes appear { */
    /* 0%{opacity:0;transform-origin:50% 50%;transform:scale(2,2);filter: blur(2px);-webkit-filter:blur(2px);} */
    /* 100%{opacity:1;transform-origin:50% 50%;transform:scale(1);filter: blur(0px);-webkit-filter:blur(0px);} */
/* } */
.drawingBoardBox {
  padding: 12px 60px;  
}

/* 标题 */
.title {
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  text-align: center;  
  display: flex;
}
.TitleleftIcon {
  flex: 4;
  width: 100%;
  height: 2px;
  background-image: linear-gradient(to left,rgba(4, 255, 244, 0.7), rgba(4, 255, 244, 0));
  position: relative;
}
.TitleleftIcon::after {
  content: '';
  display: block;
  position: absolute;
  top: 1px;
  right: 1px;
  height: 2px;
  width: 60px;
  background: rgba(4, 255, 244, 0.7);
  transform-origin: right top; 
  transform: rotate(-125deg);
}
.leftIconBox {
  float: right;
  height: 25px;
  width: 100px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.leftIcon1 {
  position: absolute;
  top: -10px;
  right: 20px;
  width: 5px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,1), rgba(4, 255, 244,0.4));
  transform: rotate(-45deg);
}
.leftIcon2 {
  position: absolute;
  top: -10px;
  right: 40px;
  width: 4px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.8), rgba(4, 255, 244,0.2));
  transform: rotate(-45deg);
}
.leftIcon3 {
  position: absolute;
  top: -10px;
  right: 60px;
  width: 4px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.5), rgba(4, 255, 244,0.1));
  transform: rotate(-45deg);
}
.leftIcon4 {
  position: absolute;
  top: -10px;
  right: 80px;
  width: 3px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.3), rgba(10, 19, 65, 1));
  transform: rotate(-45deg);
}
.titleText {
  flex: 4;
  color: rgba(177,255,252,1);
  font-size: 32px;
  line-height: 52px;
  font-weight: 500;
}
.titleText::after {
  content: '';
  display: block;
  position: relative;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%);
  background:rgba(199,186,240,1);
  background-image: linear-gradient(to right,rgba(10, 19, 65, 1), rgba(199,186,240,1), rgba(10, 19, 65, 1));
  width: 70%;
  height: 2px;

}
.TitleRightIcon {
  flex: 4;
  width: 100%;
  height: 2px;
  background-image: linear-gradient(to right,rgba(4, 255, 244, 0.7), rgba(4, 255, 244, 0));
  position: relative;
}
.TitleRightIcon::after {
  content: '';
  display: block;
  position: relative;
  top: 1px;
  left: 1px;
  height: 2px;
  width: 60px;
  background: rgba(4, 255, 244, 0.7);
  transform-origin: 0 0; 
  transform: rotate(125deg);
}
.timer {
  float: right;
  font-size: 14px;
  font-weight: 500;
  color: rgba(80, 183, 231, 1);
  margin-top: 6px;
}
.rightIconBox {
  float: left;
  height: 25px;
  width: 100px;
  margin-top: 10px;
  /* background: wheat; */
  position: relative;
  overflow: hidden;
}
.rightIcon1 {
  position: absolute;
  top: -10px;
  width: 5px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,1), rgba(4, 255, 244,0.4));
  transform: rotate(45deg);
}
.rightIcon2 {
  position: absolute;
  top: -10px;
  left: 20px;
  width: 4px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.8), rgba(4, 255, 244,0.2));
  transform: rotate(45deg);
}
.rightIcon3 {
  position: absolute;
  top: -10px;
  left: 40px;
  width: 4px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.5), rgba(4, 255, 244,0.1));
  transform: rotate(45deg);
}
.rightIcon4 {
  position: absolute;
  top: -10px;
  left: 60px;
  width: 3px;
  height: 60px;
  margin-left: 10px;
  background-image: linear-gradient(to top, rgba(4, 255, 244,0.3), rgba(10, 19, 65, 1));
  transform: rotate(45deg);
}
.infoBox {
  width: 100%;
  height: 100%;
  min-height: 1010px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 左侧盒子 */
/* .leftBox {
  flex: 5;
} */
/* 已测人数 */
.leftBox .testedPeopleNumber {
  width: 100%;
  min-width: 500px;
  height: 500px;
  position: relative;
}
.testedPeopleNumberTitle {
  font-size: 18px;
  color: #fff;
  padding: 23px 39px 20px 39px;
}
.testedPeopleNumberTitle::before {
  content: '';
  display: block;
  position: relative;
  top: 17px;
  left: -14px;
  width: 6px;
  height: 10px;
  background: rgba(4, 255, 244, 1);
  border-radius: 3px;
}
.Cumulative, .weekly {
  font-size: 12px;
  color: #fff;
  float: right;
}
.CumulativeIcon {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: rgba(26, 179, 148, 1);
  margin-right: 5px;
}
.weekly {
  margin-left: 23px;
}
.weeklyIcon {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: rgba(75, 129, 210, 1);
  margin-right: 5px;
}
.testedPeople {
  width: 90%;
}
/* 在线人数 */
.leftBox .onlinePeopleNumber {
  margin-top: 2.4%; 
  width: 100%;
  min-width: 500px;
  height: 500px;
  position: relative;
}
.onlinePeopleNumberTitle {
  font-size: 18px;
  color: #fff;
  padding: 23px 0 20px 39px;
}
.onlinePeopleNumberTitle::before {
  content: '';
  display: block;
  position: relative;
  top: 17px;
  left: -14px;
  width: 6px;
  height: 10px;
  background: rgba(4, 255, 244, 1);
  border-radius: 3px;
}
.onlinePeople {
  width: 90%;
}

/* 中间盒子 */
/* .centerBox {
  flex: 8;
} */
/* 心理健康结果 */
.centerBox .mentalHealthResult {
  position: relative;
}
.mentalHealthTitle {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 18px;
  color: #fff;
  padding: 23px 0 20px 39px;
}
.mentalHealthTitle::before {
  content: '';
  display: block;
  position: relative;
  top: 17px;
  left: -14px;
  width: 6px;
  height: 10px;
  background: rgba(4, 255, 244, 1);
  border-radius: 3px;
}
/* 右侧盒子 */
/* .rightBox {
  flex: 5;
} */
/* 学院分布 */
.rightBox .collegeDistribute {
  width: 100%;
  min-width: 500px;
  height: 500px;
  box-sizing: border-box;
  position: relative;
}
.background-canvas {
  position: absolute;
  left: 0;
  top: 0;
}
.collegeDistributeTitle {
  font-size: 18px;
  color: #fff;
  padding: 23px 0 20px 39px;
}
.collegeDistributeTitle::before {
  content: '';
  display: block;
  position: relative;
  top: 17px;
  left: -14px;
  width: 6px;
  height: 10px;
  background: rgba(4, 255, 244, 1);
  border-radius: 3px;
}
.collegeDistributeBox {
  width: 90%;
  margin: 0 auto;
}
.collegeDistributeNumber {
  height: 45px;
  width: 100%;
  margin-bottom: 4px;
}
.collegeName {
  font-size: 12px;
  color: #fff;
  margin: 0px 0px 3px 5px;
}
.allNumber {
  height: 24px;
  background: rgba(65,66,101,0.2);
  border-radius: 24px;
}
.collegePeopleNumber {
  height: 24px;
  width: 69%;
  background: linear-gradient(90deg,rgba(50,61,141,1), rgba(146,39,215,1));
  border-radius: 24px;
  box-sizing: border-box;
  text-align: right;
  font-size: 12px;
  color: #fff;
  line-height: 24px;
  padding-right: 8px;
}
/* 量表分布 */
.rightBox .scaleType {
  margin-top: 2.4%; 
  line-height: 0;
}

</style>
